import React from 'react';
import PropTypes from 'prop-types';

import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import Date from '~/components/DateComponent';

import { Container, Button, Text } from './styles';

function FooterItem({ emergency_dose, date }) {
  return (
    <Container>
      <Button>
        {emergency_dose ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />}
        <Text bold>Dose de emergência</Text>
      </Button>

      <Date date={date} />
    </Container>
  );
}

FooterItem.propTypes = {
  emergency_dose: PropTypes.bool.isRequired,
  date: PropTypes.string.isRequired,
};

export default FooterItem;
